import { useState, useRef, useContext } from "react";
import DOMPurify from "dompurify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FormatBar } from "../../components/forms/format-bar";

import "../../styles/comments.css";
import { AuthenticationContext } from "../../services/authentication/authentication.context";
import { useGlobalMedic } from "../../services/global-medic/gobal-medic.context";

export const PostComments = ({ id, load, unload, resetcmt }) => {

    const { commentDiscussion } = useGlobalMedic();

    const { token } = useContext(AuthenticationContext);

    const [mycomment, setMycomment] = useState({
        content: '',
        imageFile: null
    });

    const handleLoad = () => {
        load();
    }

    const handleUnload = () => {
        unload();
    }

    const commentRef = useRef();
    const frmRef = useRef();

    const { content, imageFile } = mycomment;

    const handleImageInput = (e) => {
        setMycomment((v) => ({ ...v, imageFile: e.target.files[0] }))
    }

    const isNull = (v) => v === '' || v === null || v === undefined;

    const handlePostComment = async () => {

        if (isNull(mycomment.content)) {
            alert('Empty comments are not allowed!');
            handleUnload();
            return;
        }


        try {
            handleLoad();
            const res = await commentDiscussion(mycomment, id, token);

            if (res?.error) {
                handleUnload();
                return alert('Something went wrong!');
            }
            handleUnload();
            alert('Comment sent!');
            setMycomment({})
            resetcmt();

        } catch (error) {
            alert(error);
            handleUnload();
            console.log({ error });
        }
    }

    return (
        <div className="comment-section">
            <form
                className="comment-box-container"
                onSubmit={(e) => {
                    e.preventDefault();
                    console.log(mycomment)
                }}
                ref={frmRef}
            >
                <FormatBar onImageChange={(e) => handleImageInput(e)} />
                <div className="comm-input-box">
                    <div className="comm-input">
                        <div
                            contentEditable
                            className="comm-input-txt"
                            ref={commentRef}
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }}
                            onBlur={() => setMycomment((v) => ({ ...v, content: commentRef.current.innerHTML }))}
                        />
                        <div className="comment-image-box">
                            {imageFile && (
                                <div className="img-frm">
                                    <button
                                        className="close-cmt-img"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setMycomment((v) => ({ ...v, imageFile: null }))
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faClose} />
                                    </button>
                                    <img
                                        src={URL.createObjectURL(imageFile)} className="comment-image"
                                        alt=""
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                    <button
                        className="comment-button"
                        onClick={async (e) => {
                            e.preventDefault();
                            await handlePostComment();
                        }}
                    >
                        <FontAwesomeIcon icon={faPaperPlane} />
                    </button>
                </div>
            </form>
        </div>
    )
}